import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {PageInvoiceOverviewDTO} from '../model/pageInvoiceOverviewDTO';
import {InvoiceDTO} from '../model/invoiceDTO';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  private readonly path = environment.baseUrl + environment.apiPrefix + 'invoice';

  constructor(private http: HttpClient) {
  }

  getInvoices() {
    return this.http.get<Array<InvoiceDTO>>(this.path);
  }

  download(paymentId) {
    return this.http.get(`${this.path}/${paymentId}/download`, {
      responseType: 'blob',
      headers: new HttpHeaders().append('content-type', 'application/json')
    });
  }

  getAll(pageIndex, pageSize, column, dir) {
    const params = new HttpParams()
      .append('page', pageIndex)
      .append('size', pageSize)
      .append('sort', `${column},${dir}`);
    return this.http.get<any>(`${this.path}/overview`, {params: params}) as Observable<PageInvoiceOverviewDTO>;
  }
}
